export default "/images/06022fe77e0c246ff4585942e8fd3d14.avif";